const jobsData = [
  {
    id: 1,
    title: "Frontend Developer",
    company: "Google",
    location: "Bangalore",
    type: "Full Time",
    experience: "0-2 Years",
    salary: "₹10 – 15 LPA",
    description:
      "We are looking for a Frontend Developer skilled in React, JavaScript, HTML, and CSS to build scalable UI applications.",
    requirements: [
      "Strong knowledge of React",
      "Good understanding of JavaScript",
      "Experience with REST APIs",
      "Basic knowledge of Git",
    ],
  },
  {
    id: 2,
    title: "React Developer",
    company: "Amazon",
    location: "Hyderabad",
    type: "Full Time",
    experience: "1-3 Years",
    salary: "₹12 – 18 LPA",
    description:
      "Amazon is hiring React Developers to work on high-scale customer-facing applications.",
    requirements: [
      "React & Redux",
      "JavaScript ES6+",
      "Performance optimization",
      "Unit testing",
    ],
  },
  {
    id: 3,
    title: "Full Stack Developer",
    company: "Microsoft",
    location: "Remote",
    type: "Remote",
    experience: "2-4 Years",
    salary: "₹15 – 22 LPA",
    description:
      "Build and maintain full stack applications using React and Node.js.",
    requirements: [
      "React",
      "Node.js",
      "MongoDB / SQL",
      "API development",
    ],
  },

  /* 🔥 NEW JOB 4 */
  {
    id: 4,
    title: "Data Analyst",
    company: "Deloitte",
    location: "Hyderabad",
    type: "Full Time",
    experience: "0-2 Years",
    salary: "₹8 – 12 LPA",
    description:
      "Analyze large datasets using SQL, Excel, Python, and Power BI to generate meaningful business insights.",
    requirements: [
      "Strong SQL skills",
      "Advanced Excel knowledge",
      "Basic Python for data analysis",
      "Understanding of statistics",
    ],
  },

  /* 🔥 NEW JOB 5 */
  {
    id: 5,
    title: "AWS Cloud Developer",
    company: "Accenture",
    location: "Bangalore",
    type: "Full Time",
    experience: "1-3 Years",
    salary: "₹12 – 20 LPA",
    description:
      "Design, deploy, and manage scalable cloud infrastructure using AWS services like EC2, S3, Lambda, and RDS.",
    requirements: [
      "Strong AWS fundamentals",
      "Knowledge of EC2, S3, RDS",
      "Linux & networking basics",
      "CI/CD understanding",
    ],
  },
];

export default jobsData;
